/* eslint-disable global-require */
module.exports = {
  Welcome: require('./dist/demo/Welcome').default,
  Button: require('./dist/demo/Button').default,
};



//////////////////
// WEBPACK FOOTER
// ./~/@storybook/react/demo.js
// module id = 246
// module chunks = 0